import { Plus } from "react-feather";
import styles from "./AddStepButton.module.scss";

export const AddStepButton = ({ children, onClick }) => (
  <button type="button" className={styles.root} onClick={onClick}>
    <Plus size={26} /> {children}
  </button>
);
